import { Link } from "react-router-dom";
import { catLabel, timeAgo, articleHref } from "@/lib/format";

// Variants: lead | secondary | standard | compact | numbered
export function ArticleCard({ a, variant = "standard", index }) {
  if (!a) return null;
  const href = articleHref(a);
  const author = a.author?.name;

  if (variant === "lead") {
    return (
      <article data-testid="hero-lead-story" className="group animate-fade-up">
        <Link to={href} className="block overflow-hidden">
          <div className="overflow-hidden">
            <img src={a.featured_image} alt={a.headline}
                 onError={(e) => { e.currentTarget.style.background = "#E2DDD5"; e.currentTarget.style.opacity = "0"; }}
                 className="w-full h-[300px] sm:h-[440px] object-cover transition-transform duration-700 group-hover:scale-[1.03] bg-subtle" />
          </div>
        </Link>
        <div className="mt-4">
          <Link to={`/${a.category}`} className="text-xs font-bold uppercase tracking-[0.18em] text-crimson">
            {catLabel(a.category)}
          </Link>
          {a.sponsored && <span className="ml-2 text-[10px] font-bold uppercase tracking-widest bg-gold/10 text-gold px-1.5 py-0.5">Sponsored</span>}
          <Link to={href}>
            <h1 data-testid="hero-lead-headline"
                className="font-serif font-bold tracking-tight leading-[1.1] text-3xl sm:text-4xl lg:text-5xl mt-2 text-ink group-hover:text-crimson transition-colors">
              {a.headline}
            </h1>
          </Link>
          <p className="mt-3 text-base sm:text-lg text-ink2 leading-relaxed max-w-2xl">{a.subtitle}</p>
          <div className="mt-3 text-xs text-mutedink font-medium flex items-center gap-2">
            {author && <span>{author}</span>}{author && <span className="text-hair">·</span>}
            <span className="font-mono">{timeAgo(a.publication_date)}</span>
          </div>
        </div>
      </article>
    );
  }

  if (variant === "secondary") {
    return (
      <article className="group py-4 border-b border-hair last:border-0">
        <Link to={`/${a.category}`} className="text-[11px] font-bold uppercase tracking-[0.16em] text-crimson">{catLabel(a.category)}</Link>
        <Link to={href}>
          <h3 className="font-serif font-semibold leading-snug text-xl mt-1.5 text-ink group-hover:text-crimson transition-colors">{a.headline}</h3>
        </Link>
        <div className="mt-1.5 text-xs text-mutedink font-mono">{timeAgo(a.publication_date)}</div>
      </article>
    );
  }

  if (variant === "compact") {
    return (
      <article className="group py-3 border-b border-hair last:border-0">
        <Link to={`/${a.category}`} className="text-[10px] font-bold uppercase tracking-[0.16em] text-crimson">{catLabel(a.category)}</Link>
        <Link to={href}>
          <h4 className="font-serif font-medium leading-snug text-base mt-1 text-ink group-hover:text-crimson transition-colors">{a.headline}</h4>
        </Link>
      </article>
    );
  }

  if (variant === "numbered") {
    return (
      <article className="group flex gap-4 py-3 border-b border-hair last:border-0 items-start">
        <span className="font-serif text-3xl font-bold text-crimson/30 leading-none w-8 shrink-0">{index}</span>
        <Link to={href}>
          <h4 className="font-serif font-medium leading-snug text-[15px] text-ink group-hover:text-crimson transition-colors">{a.headline}</h4>
        </Link>
      </article>
    );
  }

  // standard
  return (
    <article className="group animate-fade-up">
      <Link to={href} className="block overflow-hidden">
        <img src={a.featured_image} alt={a.headline} onError={(e) => { e.currentTarget.style.opacity = "0"; }} className="w-full h-44 object-cover transition-transform duration-500 group-hover:scale-[1.04] bg-subtle" />
      </Link>
      <div className="mt-3">
        <Link to={`/${a.category}`} className="text-[11px] font-bold uppercase tracking-[0.16em] text-crimson">{catLabel(a.category)}</Link>
        {a.sponsored && <span className="ml-2 text-[10px] font-bold uppercase tracking-widest bg-gold/10 text-gold px-1.5 py-0.5">Sponsored</span>}
        <Link to={href}>
          <h3 className="font-serif font-medium leading-snug text-lg sm:text-xl mt-1.5 text-ink group-hover:text-crimson transition-colors">{a.headline}</h3>
        </Link>
        <p className="mt-1.5 text-sm text-ink2 leading-relaxed line-clamp-2">{a.subtitle}</p>
        <div className="mt-2 text-xs text-mutedink font-mono">{timeAgo(a.publication_date)}</div>
      </div>
    </article>
  );
}
